import { useContext } from 'react';
import { RepositoriesContext } from './RepositoriesProvider';
export var useRepositories = function () {
    var repositories = useContext(RepositoriesContext);
    return repositories;
};
